// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const JobEmployerList = () => {
//   const [employers, setEmployers] = useState([]);
//   const [loading, setLoading] = useState(false);
// const token = localStorage.getItem("token")
//   const API_URL = process.env.REACT_APP_API_URL;

//   // Fetch employers
//   const fetchEmployers = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${API_URL}jobrecruiter/allJobEmployer`);
//       setEmployers(response.data); // adjust if response is wrapped in a data object
//     } catch (error) {
//       console.error("Error fetching employers:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update verification
//   const updateVerification = async (employerId, type, value) => {
//     try {
//       const payload = {
//         [type]: value,
//       };

//       await axios.put(`${API_URL}admin/verify-employer/${employerId}`, payload, {
//            headers: { Authorization: `Bearer ${token}` },
//       });
// console.log(token, "token sent")
//       // Update state locally to reflect the change immediately
//       setEmployers((prev) =>
//         prev.map((emp) =>
//           emp._id === employerId ? { ...emp, [type]: value } : emp
//         )
//       );
//     } catch (error) {
//       console.error("Verification update failed:", error);
//     }
//   };

//   useEffect(() => {
//     fetchEmployers();
//   }, []);

//   if (loading) {
//     return <div className="text-center py-10">Loading employers...</div>;
//   }

//   return (
//     <div className="p-6">
//       <h1 className="text-2xl font-bold mb-4">Job Employers</h1>

//       <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
//         {employers.map((employer) => (
//           <div
//             key={employer._id}
//             className="border p-4 rounded shadow hover:shadow-md transition"
//           >
//             <h2 className="text-lg font-semibold mb-1">{employer.companyName}</h2>
//             <p className="text-sm text-gray-600 mb-2">{employer.email}</p>

//             <div className="mb-2">
//               <p>
//                 <span className="font-semibold">Address Verified:</span>{" "}
//                 {employer.addressVerified ? (
//                   <span className="text-green-600">Yes</span>
//                 ) : (
//                   <span className="text-red-600">No</span>
//                 )}
//               </p>
//               <p>
//                 <span className="font-semibold">Business Verified:</span>{" "}
//                 {employer.businessVerified ? (
//                   <span className="text-green-600">Yes</span>
//                 ) : (
//                   <span className="text-red-600">No</span>
//                 )}
//               </p>
//             </div>

//             <div className="flex gap-2 flex-wrap">
//               <button
//                 className={`px-4 py-1 rounded text-white text-sm ${
//                   employer.addressVerified ? "bg-yellow-600" : "bg-green-600"
//                 }`}
//                 onClick={() =>
//                   updateVerification(
//                     employer._id,
//                     "addressVerified",
//                     !employer.addressVerified
//                   )
//                 }
//               >
//                 {employer.addressVerified ? "Unverify Address" : "Approve Address"}
//               </button>

//               <button
//                 className={`px-4 py-1 rounded text-white text-sm ${
//                   employer.businessVerified ? "bg-yellow-600" : "bg-green-600"
//                 }`}
//                 onClick={() =>
//                   updateVerification(
//                     employer._id,
//                     "businessVerified",
//                     !employer.businessVerified
//                   )
//                 }
//               >
//                 {employer.businessVerified ? "Unverify Business" : "Approve Business"}
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default JobEmployerList;






import React, { useEffect, useState } from "react";
import axios from "axios";

const JobEmployerList = () => {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // ← Added for search

  const token = localStorage.getItem("token");
  const API_URL = process.env.REACT_APP_API_URL;

  // Fetch employers
  const fetchEmployers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}jobrecruiter/allJobEmployer`);
      setEmployers(response.data);
    } catch (error) {
      console.error("Error fetching employers:", error);
    } finally {
      setLoading(false);
    }
  };

  // Update verification
  const updateVerification = async (employerId, type, value) => {
    try {
      const payload = {
        [type]: value,
      };

      await axios.put(`${API_URL}admin/verify-employer/${employerId}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(token, "token sent");

      // Update state locally
      setEmployers((prev) =>
        prev.map((emp) =>
          emp._id === employerId ? { ...emp, [type]: value } : emp
        )
      );
    } catch (error) {
      console.error("Verification update failed:", error);
    }
  };

  useEffect(() => {
    fetchEmployers();
  }, []);

  // Filter employers based on search term
  const filteredEmployers = employers.filter((employer) =>
    employer.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    employer.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return <div className="text-center py-10">Loading employers...</div>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Job Employers</h1>

      {/* Search Input - Added */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search by company name or email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full md:w-96 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {filteredEmployers.map((employer) => (
          <div
            key={employer._id}
            className="border p-4 rounded shadow hover:shadow-md transition"
          >
            <h2 className="text-lg font-semibold mb-1">{employer.companyName}</h2>
            <p className="text-sm text-gray-600 mb-2">{employer.email}</p>

            <div className="mb-2">
              <p>
                <span className="font-semibold">Address Verified:</span>{" "}
                {employer.addressVerified ? (
                  <span className="text-green-600">Yes</span>
                ) : (
                  <span className="text-red-600">No</span>
                )}
              </p>
              <p>
                <span className="font-semibold">Business Verified:</span>{" "}
                {employer.businessVerified ? (
                  <span className="text-green-600">Yes</span>
                ) : (
                  <span className="text-red-600">No</span>
                )}
              </p>
            </div>

            <div className="flex gap-2 flex-wrap">
              <button
                className={`px-4 py-1 rounded text-white text-sm ${
                  employer.addressVerified ? "bg-yellow-600" : "bg-green-600"
                }`}
                onClick={() =>
                  updateVerification(
                    employer._id,
                    "addressVerified",
                    !employer.addressVerified
                  )
                }
              >
                {employer.addressVerified ? "Unverify Address" : "Approve Address"}
              </button>

              <button
                className={`px-4 py-1 rounded text-white text-sm ${
                  employer.businessVerified ? "bg-yellow-600" : "bg-green-600"
                }`}
                onClick={() =>
                  updateVerification(
                    employer._id,
                    "businessVerified",
                    !employer.businessVerified
                  )
                }
              >
                {employer.businessVerified ? "Unverify Business" : "Approve Business"}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Show message when no results */}
      {filteredEmployers.length === 0 && searchTerm && (
        <p className="text-center text-gray-500 mt-8">
          No employers found matching "{searchTerm}"
        </p>
      )}
    </div>
  );
};

export default JobEmployerList;